<template>
    <div class="right new-chapter" :style="isShowPop?'height:100vh;overflow:hidden':''">
        <div class="chapter-title flexible aItem-center jc-between">
            <div class="page-title font-MT ">
                <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()">
                <span class="f22 page-name text-333 fwb-600">{{ chapterId =='0'?'新建章节': '修改章节'}}</span><!--{{ bookdetail.iname }}>>-->
            </div>

        </div>
        <div class="chapter-content">
<!--            <div class="list-title">-->
<!--                <div class="title f16 text-333 fwb-500">-->
<!--                    <span>章节列表</span>>>第{{ chapterId ==0?Number(sequence) + 1: sequence}}章节-->
<!--                </div>-->
<!--            </div>-->
            <div class="content-forms">
                <div>
                    <el-form ref="mainInfo" class="chapter-form" :rules="rules" :model="mainInfo">
                        <el-form-item prop="chapterTitle">

                            <el-input :disabled="mainInfo.inspectStatus == 1" v-model.trim="mainInfo.chapterTitle" class="Chapter-title f24 font-PF-R"
                                placeholder="请输入章节标题"></el-input>
                        </el-form-item>
                        <el-form-item prop="mainCon">
                            <div class="needSee flexible" v-if="needSeeFlag">
                                <div class="flex">
                                    检测到章节中有敏感词汇， 建议您改正，否则敏感词将自动替换为括号内词汇<span v-for="i in needSeeArr">{{i}}</span>
                                </div>
                                <div class="button-link" @click="saveChapterFun('save')">仍要提交</div>
                            </div>
                            <el-input @input="worknum" :disabled="mainInfo.inspectStatus == 1"  class="f18 text-333" v-model="mainInfo.mainCon"
                                type="textarea" placeholder="请输入章节内容">
                            </el-input>
                        </el-form-item>
                        <div class="chapter-btn flexible aItem-center font-MT f16">
                            <div class="flexible flex jc-between-end aItem-center">
                                <div class="text-999 f14"><i class="mr10 ">{{conLength}}</i>字</div>
                                <div class="f-csp c-btn  save-btn " @click="editReplaceContentFun()" v-if="mainInfo.inspectStatus != 1">
                                    保存
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        isWords
    } from "utils/core/kernel";
    import {
        addChapterApi,
        editChapterApi,
        getChapterInfoApi,
        getReplaceContent
    } from "apiurl/author";
    import {
        showLoading,
        hideLoading
    } from "@/utils/load";
    import { pinyin, py } from 'pinyin-pro';
    // import {
    //     mapState
    // } from "vuex";
    import {
        mapGetters
    } from 'vuex';
    export default {
        data() {
            let that = this
            /* 验证内容 */
            var mainConWords = (rule, value, callback) => {
                // console.log(value,value.length)
                if (that.chapterId=='0') {
                    if (isWords(value) < 500 || isWords(value) > 2000) {
                        callback(new Error("请输入500到2000字的章节内容"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            return {
                savesubmitType: '',
                isShowPop: false,
                chapterId: '0',
                mainInfo: {
                    mainCount: 0, // 字数
                    mainCon: "", // 正文
                    chapterTitle: "", //章节标题
                    authorCon: "", //作者的话,
                    chapterType: false,
                    submitType: '',
                    pubTime: ""
                },
                rules: {
                    chapterTitle: [{
                            required: true,
                            message: '请输入章节标题',
                            trigger: 'blur'
                        },
                        {
                            min: 1,
                            max: 30,
                            message: '请输入30字以内章节标题',
                            trigger: ['blur', 'change']
                        },
                    ],
                    mainCon: [{
                            required: true,
                            message: "请输入章节内容",
                            trigger: ['blur', 'change']
                        },
                        {
                            validator: mainConWords,
                            trigger: ['blur', 'change']
                        }
                    ]
                },
                saveChapter: {
                    mainCon: "", // 正文
                    chapterTitle: "", //章节标题
                },
                // 离开是否需要拦截
                iskeep: false,
                conLength:0, //内容字数
                replaceArr: [],
                replaceContentByPinyin: [],
                needSeeArr:[],
                needSeeFlag: false,
                charMap: [],
            };
        },
        computed: {
            ...mapGetters([
                'bookName',
                'isFree',
                'sequence'
            ]),
        },
        // computed: mapState({
        //     bookname: state => state.author.bookName
        // }),
        props: {
            bookdetail: Object
        },
        watch: {
            bookdetail(n) {
                console.log(n)
            },
        },
        mounted() {
            // console.log(this.bookName,'bookName')
            let $this = this;
            $this.chapterId=$this.$route.params.chapterId
            if ($this.chapterId != '0') {
                this.getChapterInfo()
            }
            this.getReplaceContentFun()
            // window.onbeforeunload = function(e) {
            //     e = e || window.event;
            //     // 兼容IE8和Firefox 4之前的版本
            //     if (
            //         $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
            //         $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
            //         $this.saveChapter.authorCon == $this.mainInfo.authorCon
            //     ) {
            //         //console.log("tag", "可刷新");
            //     } else {
            //         if (e) {
            //             e.returnValue = "关闭提示";
            //         }
            //         // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
            //         return "关闭提示";
            //     }
            // };
        },
        methods: {
            goBack() {
                history.back()
            },
            /* ==清空 */
            mainInfoChange() {
                this.mainInfo = {
                    chapterTitle: "", //章节标题
                    mainCon: "", // 正文
                }
            },
             //字数
            worknum(){
                // console.log(this.m /ainInfo.mainCon)
                this.conLength = isWords(this.mainInfo.mainCon)
            },

            async getChapterInfo() {
                let res = await getChapterInfoApi(this.chapterId);
                if (res.success) {
                    this.mainInfo.chapterTitle = res.data.iname;
                    this.mainInfo.mainCon = res.data.content;
                    this.conLength = isWords(this.mainInfo.mainCon)
                    this.mainInfo.inspectStatus = res.data.inspectStatus;
                }
            },
            // 保存内容
            saveChapterFun(flag) {
                this.$refs.mainInfo.validate(valid => {
                    if (valid) {
                        if (this.chapterId != '0') {
                            // console.log( typeof  BigInt(this.$route.params.chapterId))
                            let params = {
                                chapterId: this.chapterId,
                                name: this.mainInfo.chapterTitle,
                                content: this.mainInfo.mainCon
                            }
                            showLoading()
                            editChapterApi(this.qs.stringify(params))
                                .then(res => {
                                    if (res.success) {
                                        hideLoading()
                                        this.iskeep = true
                                        this.closeFun()
                                        this.$success('upd')
                                        this.$router.push("/author/authorManage/chapterList/" + this.$route
                                            .params.id);
                                        this.$emit('changeChapter', '')
                                    } else {
                                        hideLoading()
                                    }
                                })
                                .catch(() => {
                                    hideLoading()
                                });

                        } else {
                            console.log(this.$route.params.id, 'id')
                            // console.log( typeof  BigInt(this.$route.params.id))
                            let params = {
                                bookId: this.$route.params.id,
                                name: this.mainInfo.chapterTitle,
                                content: this.mainInfo.mainCon,
                            }
                            showLoading()
                            addChapterApi(this.qs.stringify(params))
                                // addChapterApi(params)
                                .then(res => {
                                    console.log(res)
                                    if (res.success) {
                                        hideLoading()
                                        this.iskeep = true
                                        this.closeFun()
                                        this.$success('add')
                                        this.$router.push("/author/authorManage/chapterList/" + this.$route
                                            .params.id);
                                        this.$emit('changeChapter', '')
                                    } else {
                                        hideLoading()
                                    }
                                })
                                .catch(() => {
                                    hideLoading()
                                });
                        }
                    }
                })
            },
            //获取敏感词
            async getReplaceContentFun (){
                this.replaceArr =[]
                let res = await getReplaceContent();
                console.log(res)
                if (res.success) {
                    this.replaceArr = res.data.replaceContent;
                    this.replaceContentByPinyin = res.data.replaceContentByPinyin
                    // this.replaceArr = ['/xijinping/i_**','毛[\\s\\S]{0,1}主席_**', '老[\\s\\S]{0,1}毛_**', '毛[\\s\\S]{0,1}泽_**', '毛[\\s\\S]{0,1}ze_**', '泽[\\s\\S]{0,1}东_**'];
                    // this.replaceContentByPinyin = ['毛主席'];
                }
            },
            //处理敏感词
            editReplaceContentFun(){
                this.needSeeArr = []
                let onearr = [];
                let twoarr = [];
                this.replaceArr.forEach((item,index) => {
                    var twoItem = item.split('_');
                    onearr.push(twoItem[0]);
                    twoarr.push(twoItem[1])
                });

                onearr.forEach((item,index)=> {
                    if(item.indexOf('(?i)') > -1){
                        item = item.replace('(?i)', '')
                        const reg = new RegExp(item, 'i');
                        if(reg.test(this.mainInfo.mainCon)){
                            const matchRegGlobal = new RegExp(item, 'gi');
                            const matchTextList = this.mainInfo.mainCon.match(matchRegGlobal);
                            this.needSeeArr.push(matchTextList+"("+twoarr[index]+")")
                        }
                    } else {
                        const reg = new RegExp(item);
                        if(reg.test(this.mainInfo.mainCon)){
                            const matchRegGlobal = new RegExp(item, 'gi');
                            console.log(matchRegGlobal)
                            const matchTextList = this.mainInfo.mainCon.match(matchRegGlobal);
                            this.needSeeArr.push(matchTextList+"("+twoarr[index]+")")
                        }
                    }
                });
                //同音字处理 测试: 猫煮喜
                let pinyinStr = this.convertToPinyinRule(this.mainInfo.mainCon);
                console.log(pinyinStr)
                this.replaceContentByPinyin.forEach((item, index)=>{
                    //敏感词转换为拼音数组
                    const targetPinyinArr = pinyin(item, { toneType: 'none', type: 'array' });
                    console.log(targetPinyinArr)
                    //同音字循环结果比对
                    const result = this.getAllMatchedOriginalStr(targetPinyinArr, this.charMap);
                    console.log(result)
                    if(result){
                        this.needSeeArr.push(result+"(**)")
                    }
                })
                console.log(this.needSeeArr)
                if(this.needSeeArr.length != 0){
                    this.needSeeFlag = true
                } else{
                    this.needSeeFlag = false
                    this.saveChapterFun()
                }
            },
            //汉字转同音字
            convertToPinyinRule(rule) {
                // 步骤2：遍历每个字符，区分中文和正则语法，仅转换中文为拼音
                let result = '';
                this.charMap = []
                for (const char of rule) {
                    const charPinyin = pinyin(char, { toneType: 'none' });
                    if (charPinyin) { // 是汉字，存拼音
                        result += charPinyin;
                        this.charMap.push({ type: 'pinyin', value: charPinyin, original: char });
                    } else { // 非汉字，直接存原字符
                        result += char;
                        this.charMap.push({ type: 'char', value: char, original: char });
                    }
                }
                // console.log(this.charMap)

                // for (const char of rule) {
                //     // 判断是否为中文汉字（Unicode 范围：\u4e00-\u9fa5）
                //     const isChinese = /[\u4e00-\u9fa5]/.test(char);
                //     if (isChinese) {
                //         // 中文转无声调拼音
                //         const charPinyin = pinyin(char, { tone: false});
                //         result += charPinyin;
                //     } else {
                //         // 非中文（正则语法）直接保留
                //         result += char;
                //     }
                // }
                return result
            },
            //同音字循环结果比对
            getAllMatchedOriginalStr(targetPinyinArr, pinyinMapArr) {
                const targetLen = targetPinyinArr.length;
                const mapLen = pinyinMapArr.length;
                const allMatches = [];

                // 边界防护：目标拼音数组更长，直接返回空
                if (targetLen > mapLen) return '';

                // 遍历查找所有匹配片段
                for (let i = 0; i <= mapLen - targetLen; i++) {
                    const currentSubArr = pinyinMapArr.slice(i, i + targetLen);
                    const currentPinyinArr = currentSubArr.map(item => item.value);

                    // 匹配成功则拼接汉字并存入数组
                    if (JSON.stringify(currentPinyinArr) === JSON.stringify(targetPinyinArr)) {
                        allMatches.push(currentSubArr.map(item => item.original).join(''));
                    }
                }

                // 核心格式化：先用地中文顿号拼接结果，再包裹单引号
                return allMatches.length > 0 ? `'${allMatches.join('、')}'` : '';
            },
             // 关闭弹框
            closeFun() {
                this.isShowPop = false
                this.$emit('changePop', false)
            },
        },
        // beforeRouteLeave(to, from, next) {
        //     let $this = this;
        //     if ($this.iskeep = true) {
        //         next();
        //     } else if (
        //         $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
        //         $this.saveChapter.mainCon == $this.mainInfo.mainCon
        //     ) {
        //         next()
        //     } else {
        //         let a = window.confirm("离开页面更改的内容将丢失！");
        //         if (a) {
        //             next();
        //         } else {
        //             next(false);
        //         }
        //     }
        // },

        beforeDestroy() {}
    };
</script>
<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .chapter-title {
        // padding: 40px !important;
    }

    .list-title {
        .title {
            padding-bottom: 10px;
            border-bottom: 1px solid #F2F2F2;
        }
    }

    .chapter-content {
        padding: 20px 0;
    }

    .content-forms {
        // padding: 20px 40px;
        margin-top: 20px;

        .save-btn {
            width: 90px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            color: #fff;
            background: #F68A01;
            border-radius: 20px;
            margin-left: 20px;

        }
    }

    .new-chapter {
        padding: 40px 40px 0 !important;

        .chapter-form {
            /deep/ .el-form-item__label {
                color: #333 !important;
                font-size: 16px;
            }

            /deep/ .el-input__inner {
                border: none;
                // border-bottom: 1px solid #eee;
                color: #333 !important;
                height: 40px;
                background: #F5F5F5;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
            }

            /deep/ .el-textarea__inner {
                background: #FBFBFB;
                border: 1px solid #DDDDDD;
                min-height: 700px !important;
                padding: 20px;
                color: #333;
                line-height: 40px;
                border: none;
                font-size: 14px;
            }

            /*输入框*/
            /deep/.el-form-item.is-error .el-input__inner,
            /deep/.el-form-item.is-error .el-input__inner:focus,
            /deep/.el-form-item.is-error .el-textarea__inner,
            /deep/.el-form-item.is-error .el-textarea__inner:focus,
            /deep/.el-message-box__input input.invalid,
            /deep/.el-message-box__input input.invalid:focus {
                border-color: #F56C6C !important;
            }

            /deep/ .el-form {
                width: 100%;
                display: inline-block;
                margin-top: 20px;
            }

        }

    }
    .needSee{
        padding: 8px 35px 8px 14px;
        background-color: #fcf8e3;
        border: 1px solid #fbeed5;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        color: #c09853;
        span{
            color: #ff0000;
            margin-right: 10px;
        }
        .button-link{
            color: #0a8abf;
            margin-left: 30px;
            cursor: pointer;
        }
    }
</style>
